import React from 'react';

import { EditorState, getDefaultKeyBinding } from 'draft-js';

import { linkKeyBindingHandler } from '../Toolbar/Items/Link';
import * as t from '../Wysiwyg.types';

export const useKeyBindingFn = ({
  editorState,
  keyBindingHandler,
  blur,
}: {
  editorState: EditorState;
  keyBindingHandler?: t.KeyBindingHandler;
  blur: () => void;
}) => {
  const keyBindingFn = (e: React.KeyboardEvent): string | null => {
    // From props
    if (keyBindingHandler) {
      const command = keyBindingHandler(e, editorState);
      if (command) return command;
    }

    // Link
    const linkKeyBinding = linkKeyBindingHandler(e);
    if (linkKeyBinding) return linkKeyBinding;

    if (e.key === 'Tab') {
      blur();
    }

    // Default
    return getDefaultKeyBinding(e);
  };

  return keyBindingFn;
};
